import React, { useEffect } from 'react'
import { Tabs } from 'antd'
import { useParams } from 'react-router-dom'

import AppLayout from 'components/layout/layout'
import Loader from 'helper/Loader'
import { useGetCommunityById } from 'api/Community/CommunityCreation'
import ProfileHeaderCommunity from './ProfileHeaderCommunity'
import CommunityDetails from './Tabs/Details'
import { CommunityResp } from 'types/community/community'

const { TabPane } = Tabs

const CommunityDetail: React.FC = () => {
  const { id } = useParams<{ id: string }>()

  const { data, isLoading, isFetching, refetch, isError } = useGetCommunityById(
    id as string,
  )

  const community = data as CommunityResp | undefined

  useEffect(() => {
    if (id) {
      refetch()
    }
  }, [id, refetch])

  if (isLoading || isFetching) {
    return <Loader />
  }

  if (isError) {
    return (
      <AppLayout>
        <div className="container bg-grey">
          <div className="org-profile-header pt-30">
            <h1>Something went wrong</h1>
          </div>
        </div>
      </AppLayout>
    )
  }

  return (
    <AppLayout>
      <div className="container bg-grey">
        <div className="org-profile-header pt-30">
          <ProfileHeaderCommunity community={community} />
        </div>
        <Tabs defaultActiveKey="1" className="bg-white profile-tabs">
          <TabPane tab="Details" key="1">
            <CommunityDetails community={community} />
          </TabPane>
        </Tabs>
      </div>
    </AppLayout>
  )
}

export default CommunityDetail
